import {
  GET_PERSON_PROFILE_REQ,
  GET_PERSON_PROFILE_RES,
  PersonProfileTypes,
  FAILED_REQUEST,
  UPDATE_PERSON_PROFILE_REQ,
  UPDATE_PERSON_PROFILE_RES,
} from './types';
import { PersonModel } from '../../models/personModel';
import { AppThunk } from '..';
import {
  getPersonalDetailsReq,
  updatePersonalDetailsReq,
} from '../../api/person/personalDetailsApi';
import { PhoneType } from '../../models/eums/phoneType';
import { EmailType } from '../../models/eums/emailType';
import { convertToIsoDateFormat } from '../../utils/dateUtils';

function getPersonProfileStart(): PersonProfileTypes {
  return {
    type: GET_PERSON_PROFILE_REQ,
  };
}

function getPersonProfileFinish(profileDetails: PersonModel): PersonProfileTypes {
  return {
    type: GET_PERSON_PROFILE_RES,
    payload: profileDetails,
  };
}

function updatePersonProfileStart(): PersonProfileTypes {
  return {
    type: UPDATE_PERSON_PROFILE_REQ,
  };
}

function updatePersonProfileFinish(profileDetails: PersonModel): PersonProfileTypes {
  return {
    type: UPDATE_PERSON_PROFILE_RES,
    payload: profileDetails,
  };
}

function requestError(error: string): PersonProfileTypes {
  return {
    type: FAILED_REQUEST,
    payload: error,
  };
}

export function getPersonProfile(): AppThunk {
  return async function (dispatch) {
    dispatch(getPersonProfileStart());
    try {
      const response = await getPersonalDetailsReq();
      handleResponseData(response.data);

      dispatch(getPersonProfileFinish(response.data));
    } catch (error) {
      dispatch(requestError(error));
    }
  };
}

function handleResponseData(data: any) {
  if (data.birthDate) {
    data.birthDate = convertToIsoDateFormat(data.birthDate);
  }
  if (!data.coms) {
    data.coms = {
      phoneNumbers: [{ phoneType: PhoneType.Mobile, phoneNumber: '' }],
      emailAddresses: [{ emailType: EmailType.Primary, emailAddress: '' }],
    };
  }
}

export function updatePersonProfile(profile: PersonModel, image?: File): AppThunk {
  return async function (dispatch) {
    dispatch(updatePersonProfileStart());
    try {
      const response = await updatePersonalDetailsReq(profile, image);
      dispatch(updatePersonProfileFinish(response.data));
    } catch (error) {
      dispatch(requestError(error));
    }
  };
}
